import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { AlertTriangle, Info, XCircle } from 'lucide-react';

interface AccessWarningProps {
    type: 'noAccess' | 'noKBAccess' | 'partialAccess';
    indexCount?: number;
    totalIndexes?: number;
}

const AccessWarning: React.FC<AccessWarningProps> = ({ type, indexCount, totalIndexes }) => {
    const variants = {
        noAccess: {
            icon: XCircle,
            label: "No Access",
            variant: "text-danger",
            description: "You don't have access to this RAG application. Please contact your administrator."
        },
        noKBAccess: {
            icon: AlertTriangle,
            label: "Limited Access",
            variant: "text-orange",
            description: "You have access to this RAG application, but you don't have access to any of its indexes. Please contact your administrator for access to the required indexes."
        },
        partialAccess: {
            icon: Info,
            label: "Partial Access",
            variant: "text-info",
            description: `You have access to ${indexCount} out of ${totalIndexes} indexes in this application.`
        }
    } as const;

    const config = variants[type];
    const Icon = config.icon;

    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip id={`tooltip-${type}`}>
                    {config.description}
                </Tooltip>
            }
        >
            <div className="d-inline-flex align-items-center gap-1">
                <Icon size={16} className={config.variant} />
                <span className={`small ${config.variant}`}>
                    {config.label}
                </span>
            </div>
        </OverlayTrigger>
    );
};

export default AccessWarning;